import "./Project.css";
// import $ from "jquery";
import Card from "../components/Card";
// import pic1 from "../pics/1.jpg";
// import pic2 from "../pics/fire.jpg";
import { data } from "./Projectlist";
function Project() {
  return (
    <div className="container" id="project">
      <div>
        <h1 className="project-head">Web is fun.</h1>
      </div>

      <div className="project-main row" >
        {data.map((e) => {
          return <Card className="cards" title={e.title} image={e.image} content={e.content} link={e.link} github={e.github} tags={e.tags}/>;
        })}
      </div>
    
    </div>
  );
}

export default Project;
